module.exports = __webpack_public_path__ + "img/social-icon.224e7fd4.svg";